

import React from 'react';
import { Typography, Divider } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import { Row, Col } from 'antd';
// import arrow from '../../assets/images/black_arrow.svg';
import "./index.css";

const Question = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  

  return (
    <div
      className="mb-5 mt-5 text-[black]"
      style={{
        fontFamily: 'Roboto, sans-serif',
        padding: isMobile ? '0 16px' : '0 32px',
      }}
    >
      <div mb={2}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}>
          <ul
            style={{
              marginLeft: isMobile ? '0' : '20px',
              listStyleType: 'disc',
              fontSize: isMobile ? '14px' : '16px',
            }}
          >
            <li>
              <Typography>
                Plan mi trip is one of the most attractive & first ever reward program
                <p>by any travel & tour operator with a vast range of fully packaged holidays within</p>
                <p>India & all major holiday destinations across the world.</p>
              </Typography>
            </li>
            <li>
              <Typography>
                Now you will be able to collect reward points every time you holiday with us and use
                <p>those reward points to book flights, hotels or holidays with us.</p>
              </Typography>
            </li>
            <li>
              <Typography>
                You can also win surprise bonus points on sharing more details about yourself or
                <p>referring clients and buying Forex from us.</p>
              </Typography>
            </li>
          </ul>
        </div>
      </div>

      <Divider
        style={{
          fontWeight: "bold",
          fontSize: '10px',
          backgroundColor: '#000',
          height: '2px',
          margin: '45px 0px 0px 0px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Typography style={{
          padding: '0 25px',
          fontSize: "24px",
          fontWeight: "600",
          lineHeight: "2em",
          color: "#ea232a",
          fontFamily: 'Roboto, sans-serif',
          backgroundColor: '#F5F5F5'
        }}>
          Loyalty Tier Benefits
        </Typography>
      </Divider>

      <Row gutter={[16, 16]} style={{ backgroundColor: '#F5F5F5', marginTop: "60px" }}>
        <Col xs={24} md={8}>
          <div style={{ height: '90px', border: '2px solid #000' }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#565857", padding: "0 10px" }}>
              <Typography style={{ color: "white", fontWeight: "600", whiteSpace: 'nowrap', fontSize: "16px" }}>
                Loyalty Tier
              </Typography>
            </div>
            <ul style={{ display: "flex", justifyContent: 'space-around', alignItems: "center" }}>
              <li style={{ display: "flex", flexDirection: "column", margin: "10px" }}>
                <Typography align="center"><b>Silver</b></Typography>
                <Typography align="center">(First Holiday with us)</Typography>
              </li>
            </ul>
          </div>
          <div style={{ height: '90px', border: '2px solid #000', borderTop: 0 }}>
            <ul style={{ display: "flex", justifyContent: 'space-around', alignItems: "center" }}>
              <li style={{ display: "flex", flexDirection: "column", margin: "10px" }}>
                <Typography align="center"><b>Gold</b></Typography>
                <Typography align="center">(Loved the first & came for second)</Typography>
              </li>
            </ul>
          </div>
        </Col>

        <Col xs={24} md={8}>
          <div style={{ height: '90px', border: '2px solid #000' }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#565857", padding: "0 10px" }}>
              <Typography style={{ color: "white", fontWeight: "600", whiteSpace: 'nowrap', fontSize: "16px" }}>
                Cash Benefits
              </Typography>
            </div>
            <ul style={{ display: "flex", justifyContent: 'space-around', alignItems: "center" }}>
              <li style={{ display: "flex", flexDirection: "column", margin: "10px" }}>
                <Typography align="center"><b>1% of the sale</b></Typography>
                <Typography align="center">Which can be used for next purchase</Typography>
              </li>
            </ul>
          </div>
          <div style={{ height: '90px', border: '2px solid #000', borderTop: 0 }}>
            <ul style={{ display: "flex", justifyContent: 'space-around', alignItems: "center" }}>
              <li style={{ display: "flex", flexDirection: "column", margin: "10px" }}>
                <Typography align="center"><b>1.5% of the sale</b></Typography>
                <Typography align="center">Which can be used for next purchase</Typography>
              </li>
            </ul>
          </div>
        </Col>

        <Col xs={24} md={8}>
          <div style={{ height: '180px', border: '2px solid #000', display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#565857", padding: "0 10px" }}>
              <Typography style={{ color: "white", fontWeight: "600", whiteSpace: 'nowrap', fontSize: "16px" }}>
                Bonus
              </Typography>
            </div>
            <ul style={{ display: "flex", justifyContent: 'space-around', alignItems: "center" }}>
              <li style={{ display: "flex", flexDirection: "column", margin: "0px 10px 50px 10px" }}>
                <Typography align="center">
                  <p>If the sale value of the lead booker goes above ₹15 Lacs in a year, he/she will be eligible for a 0.5% worth of points as an additional kicker</p>
                </Typography>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Question;

